<template>
  <div
    v-if="memberShow"
    id="PersonalInformation"
    class="well"
    style="padding: 0 1em"
  >
    <div class="course_title">學生篇學籍基本資料</div>

    <div class="form-group">
      <table class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。<br>
                (學校幾乎都用email跟手機通知大家因此請同學提供有在使用的email及手機)
                </span
              >
            </td>
          </tr>
          <tr align="left">
            <td>班 級</td>
            <td>
              <div class="input-group-text">
                {{ inputData.clsnm }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>年 級</td>
            <td>
              <div class="input-group-text">
                {{ inputData.gd }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>專班名</td>
            <td>
              <div class="input-group-text">
                {{ inputData.specialClassName }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>學 號</td>
            <td>
              <div class="input-group-text">
                {{ inputData.sid }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>身分證字號</td>
            <td>
              <div class="input-group-text">
                {{ inputData.idno }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>姓 名</td>
            <td>
              <div class="input-group-text">
                {{ inputData.name }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>手 機</td>
            <td>
              <div class="input-group-text">
                {{ inputData.mobiphone }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr align="left">
            <td>戶籍住址</td>
            <td>
              <div class="input-group-text">
                {{ inputData.hmadd1 }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>eMail

            </td>
            <td>
              <div class="input-group-text">
                {{ inputData.eMail }}
              </div>
              <br>
              <span>
                <a href="mail說明.jpg" target="_blank">
                  請從學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)修改，修改方式可參考此圖片
                </a>
              </span>
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr align="left">
            <td>產學攜手專班經濟不利助學金匯款資料</td>
            <td>
              請提供本人帳戶(欄位空白請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)填寫資料再進來申請)
            <br>
              <span>
                <a href="https://docs.google.com/presentation/d/11Ypy1NHQikHNEMYemKiqzYRKrrB4zfRbihNNDrs7DDA/edit#slide=id.p1" target="_blank">
                  學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)銀行帳戶登入使用說明
                </a>
              </span>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>聯絡手機</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.contactPhone"
                pattern="/^\d{10}$/"
                onKeyPress="if(this.value.length==10) return false;"
                placeholder="輸入聯絡手機"
                required
              />
            </td>

            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>銀行名稱</td>
            <td>
              <div class="input-group-text">
                {{ inputData.postname }}
              </div>
            </td>

            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>分行名稱</td>
            <td>
              <div class="input-group-text">
                {{ inputData.postsubName }}
              </div>
            </td>

            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>分行代碼(必填7碼)</td>
            <td>
              <div class="input-group-text">
                {{ inputData.postsubID }}
              </div>
            </td>

            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>銀行帳號</td>
            <td>
              <div class="input-group-text">
                {{ inputData.postno }}
              </div>
            </td>

            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>
              <span style="color: #f00">＊</span>金融帳戶封面影本(轉帳申請單)
            </td>
            <td>
              <span v-if="inputData.url != null">
                <a :href="inputData.url" target="_blank">
                  <img src="@/assets/images/disk.png" />
                </a>
              </span>
            </td>

            <td></td>
            <td></td>
          </tr>

          <tr style="text-align: center">
            <td></td>

            <td>
              <button
                class="btn active bg-info text-white rounded"
                @click="addMember()"
              >
                送出資料
              </button>
            </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "PersonalInformation",
  props: ["sid"],
  data() {
    return {
      file1: null,
      file2: null,
      // memberShow: this.$store.state.user2,
      memberShow: false,
      inputData2: this.$store.state.inputData,
      inputData: null,
      mode: false,
      //file: [{ name: "", RowId: "" }],
      file: null,
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        //   postid: "", //銀行總代號
        id: "",
        stdID: "",
        postname: "", //銀行名稱
        postno: "", //銀行帳號
        postsubID: "", //分行代碼(必填7碼)前三碼是銀行總代號
        postsubName: "", //分行名稱
        url: null, //銀行影本網址
        Info: [],
        sid: "",
        RowId: "",
        name: "",
        dptcd: "",
        startYear: 0,
        idno:null,
        contactPhone:null,
      },
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    CaseSelect(id) {
      this.$emit("CaseSelect", id);
    },
    isEmpty(data) {
      return data != null && data != undefined && data.length > 0
        ? false
        : true;
    },
    checkSaveData() {
      var msg = "";

      if (this.isEmpty(this.queryInfo.contactPhone)) {
        msg = "請輸入聯絡手機資訊";
      } else if (this.isEmpty(this.inputData.postname)) {
        msg = "請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)輸入銀行名稱";
      } else if (this.isEmpty(this.inputData.postsubName)) {
        msg = "請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)輸入分行名稱";
      } else if (this.isEmpty(this.inputData.postsubID)) {
        msg = "請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)輸入分行代碼(必填7碼)前三碼是銀行總代號";
      } else if (this.isEmpty(this.inputData.postno)) {
        msg = "請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)輸入銀行帳號";
      } else if (this.isEmpty(this.inputData.url)) {
        msg = "請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)上傳金融帳戶封面影本";
      } else if (this.isEmpty(this.inputData.specialClassName)) {
        msg = "同學不是產學攜手專班請勿申請!!";
      }


      return msg;
    },
    addMember: function () {
      var msg = this.checkSaveData();
      if (msg.length != 0) {
        alert(msg);
        return null;
      }

      let vm = this;
      vm.queryInfo.sid = vm.inputData2.usrData.id;
      if (vm.mode == false) {
        console.log(vm.queryInfo);
        //新增
        this.$http
          .put(
            "./WebApi/EconomicDisadvantage/SetReportsStudentBank/",
            vm.queryInfo
          )
          .then((response) => {
            if (0 < response.data) {
              alert("新增更新成功");
              this.CaseSelect(2);

            }

          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    isNullOrEmpty(s) {
      return s == null || s === "";
    },

    getStudentInfo2: function () {
      var vm = this;
      if (!vm.isNullOrEmpty(vm.inputData2)) var id = vm.inputData2.usrData.id;
      else var id = vm._props.sid;

      this.$http
        .get("./WebApi/EconomicDisadvantage/GetStudentInfo2/".concat(id))
        .then((response) => {
          if (response.data != null) {
            console.log(response.data);
            vm.memberShow = true;
            vm.inputData = response.data;
            vm.queryInfo.sid = response.data.sid;
            vm.queryInfo.startYear = response.data.inschyy;
            vm.queryInfo.dptcd = response.data.dptcd;
            vm.queryInfo.idno = response.data.idno;
            vm.queryInfo.contactPhone = response.data.contactPhone;
          }
        })
        .catch(function (error) {
          tools.showAlert(
            vm,
            "danger",
            "對不起, 登入失敗, 請檢查帳號是否輸入正確"
          );
        });
    },
  },
  created() {
    console.log("======created PersonalInformationView =====");

    this.getStudentInfo2();
  },


  mounted() {
    console.log("======mounted StdLoginView  =====");


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
